import {
  TRegisterDeviceTokenReqDto,
  TRegisterDeviceTokenResDto,
  TUnregisterDeviceTokenReqDto,
} from "@/api/services/main/app-notification/dtos/device-token.dto";
import {
  TGetNotificationListReqDto,
  TGetNotificationListResDto,
  TUnreadCountResDto,
} from "@/api/services/main/app-notification/dtos/notification-inbox.dto";
import { TApiRes } from "@/types/api";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useMutation, useQuery } from "@tanstack/react-query";

// --- Device Token ---

export const registerDeviceTokenApi = async (payload: TRegisterDeviceTokenReqDto): Promise<TRegisterDeviceTokenResDto> => {
  const rs = await clientApi.post<TRegisterDeviceTokenResDto>("/notification/device-token", payload);
  return rs.data;
};

export const unregisterDeviceTokenApi = async (payload: TUnregisterDeviceTokenReqDto): Promise<TApiRes<boolean>> => {
  const rs = await clientApi.delete<TApiRes<boolean>>("/notification/device-token", { data: payload });
  return rs.data;
};

export const useRegisterDeviceToken = () => {
  return useMutation({
    mutationFn: registerDeviceTokenApi,
    retry: 3,
  });
};

export const useUnregisterDeviceToken = () => {
  return useMutation({
    mutationFn: unregisterDeviceTokenApi,
    retry: 3,
  });
};

// --- Notification Inbox ---

export const fetchNotificationListApi = async (params: TGetNotificationListReqDto): Promise<TGetNotificationListResDto> => {
  const rs = await clientApi.get<TGetNotificationListResDto>("/notification", { params });
  return rs.data;
};

export const fetchUnreadCountApi = async (): Promise<TUnreadCountResDto> => {
  const rs = await clientApi.get<TUnreadCountResDto>("/notification/unread-count");
  return rs.data;
};

export const markAllAsReadApi = async (): Promise<TApiRes<boolean>> => {
  const rs = await clientApi.patch<TApiRes<boolean>>("/notification/read-all");
  return rs.data;
};

export const markAsReadApi = async (id: number): Promise<TApiRes<boolean>> => {
  const rs = await clientApi.patch<TApiRes<boolean>>(`/notification/${id}/read`);
  return rs.data;
};

export const useNotificationList = (params: TGetNotificationListReqDto) => {
  return useQuery({
    queryKey: [QUERY_KEYS.NOTIFICATION.LIST, params],
    queryFn: () => fetchNotificationListApi(params),
  });
};

export const useUnreadCount = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.NOTIFICATION.UNREAD_COUNT],
    queryFn: fetchUnreadCountApi,
  });
};
